import React from "react";
import BrandCard from "./BrandCard";
import { Container, Row, Spinner } from "react-bootstrap";
import { t } from "i18next";
import Cookies from "js-cookie";
import BrandPageHook from "../../hook/brand/BrandPageHook";
const BrandContainer = ({ data, loading }) => {
  return (
    <Container className="py-5">
      <div className="section-title-modern text-center mb-5">
        <h2 style={{ fontWeight: 800, color: 'var(--primary-color)' }}>{t("All brands")}</h2>
        <div className="title-underline"></div>
      </div>
      <div className="d-flex flex-wrap justify-content-center" style={{ gap: '20px' }}>
        {/* <BrandCard img={brand1} /> */}

        {(
          data ? (
            data.map((el) => {
              return <BrandCard brand={el} id={el._id} key={el._id} img={el.logo} />;
            })
          ) : (
            <h3 className="text-center">{t("no brands")} </h3>
          )
        // ) : (
        //   <Spinner animation="border" variant="primary" />
        )}
      </div>
    </Container>
  );
};

export default BrandContainer;
